module.exports = __webpack_public_path__ + "static/img/indexCover02.fb42c8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/indexCover02.png
// module id = xx/c
// module chunks = 3